/* eslint-disable camelcase */

export default class DtoActionTable {
    constructor(obj) {
        this.idAction = obj.idAction // Option[Long] = None,
        this.idDiag = obj.idDiag // Option[Long] = None,
        this.idDanger = obj.idDanger // Option[Long] = None,
        this.creationDate = obj.creationDate // Option[DateTime] = None,
        this.risk = obj.risk // Option[Long] = None,
        this.localisation = obj.localisation // Option[Long] = None,
        this.equipmentType = obj.equipmentType // Option[Long] = None,
        this.category = obj.category // Option[Long] = None,
        this.responsible = obj.responsible // Option[Long] = None,
        this.deadline = obj.deadline // Option[Int] = None,
        this.interventionType = obj.interventionType // Option[Long] = None,
        this.comment = obj.comment // Option[String] = None,
        this.correctionDate = obj.correctionDate // Option[DateTime] = None,
        this.commentCorrection = obj.commentCorrection // Option[String] = None,
        this.updateLogin = obj.updateLogin // Option[String] = None,
        this.updateDate = obj.updateDate // Option[DateTime] = None,
        this.link_docs = obj.link_docs // Option[Seq[ActionDoc]] = None
    }
}
